import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import jwt_decode from 'jwt-decode';
import { IonGrid } from '@ionic/angular/standalone';
import { GlobalStorage } from 'src/app/apv/core/services/globals.service';
import { scrollViewToTop } from 'src/app/apv/core/utils/functions';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SubscriptionExitService } from '../../services/subscription-exit.service';
import { SubscriptionStore } from '../../services/subscription.store';
@Component({
  selector: 'app-subscription-flow-page',
  templateUrl: './subscription-flow.page.html',
  styleUrl: './subscription-flow.page.scss',
  imports: [IonGrid, CommonModule, RouterModule, BreadcrumbComponent],
})
export class SubscriptionFlowPage implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  public user: any = {};
  constructor(
    private readonly router: Router,
    private readonly globalSvc: GlobalStorage,
    private readonly store: SubscriptionStore,
    private readonly exitSvc: SubscriptionExitService,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}
  ngOnInit(): void {
    this.getUserDataFromToken();
    this.exitSvc.attachModal();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        filter(() => this.isRedesignedStep),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.store.setLastStepUrl(this.router.url);
        scrollViewToTop(this.elementRef.nativeElement);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private readonly redesignedRoutes = [
    '/paso/1',
    '/paso/2',
    '/paso/3',
    '/paso-agregar-empleador/3',
    '/paso/4',
  ];

  get isRedesignedStep(): boolean {
    return this.redesignedRoutes.some((route) => this.router.url.includes(route));
  }

  private readonly getUserDataFromToken = () => {
    try {
      const token = this.globalSvc;
      const decodedToken: any = jwt_decode(token.token);

      this.user = {
        name: decodedToken.name,
        lastName: decodedToken.lastName,
        rut: decodedToken.user_id,
        email: decodedToken.email,
      };
      this.globalSvc.userData = this.user;
    } catch (error) {
      console.error('Error getting user data from token');
      console.log(error);
    }
  };
}
